import { render } from "./wallet-accounts-table.vue?vue&type=template&id=f4533fe0&scoped=true"
import script from "./wallet-accounts-table.vue?vue&type=script&lang=js"
export * from "./wallet-accounts-table.vue?vue&type=script&lang=js"

import "./wallet-accounts-table.vue?vue&type=style&index=0&id=f4533fe0&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4533fe0"]])

export default __exports__